import analytics from './../analytics';

export default {
    mounted() {
        const objectToSendWithPageViewAnalyticsEvent = this.objectToSendWithPageViewAnalyticsEvent || null;

        let data = {
            loan_id: this.loan?.id ?? null,
            user_id: this.user?.id ?? this.loan?.user_id ?? null,
            loan_status: this.loan?.status ?? null,
            page_name: this.gTagPageName,
        };

        if(objectToSendWithPageViewAnalyticsEvent) {
            data = {...data, ...objectToSendWithPageViewAnalyticsEvent};
        }

        const pageName = this.gTagPageName ?? 'UKNOW_PAGE_NAME';

        analytics.dinamicPageEvents('PAGE_VIEW', pageName).pageView(data);
    },
};